import { render, staticRenderFns } from "./begin.vue?vue&type=template&id=553c1800&scoped=true&"
import script from "./begin.vue?vue&type=script&lang=js&"
export * from "./begin.vue?vue&type=script&lang=js&"
import style0 from "./begin.vue?vue&type=style&index=0&id=553c1800&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553c1800",
  null
  
)

export default component.exports